/** 当前完整 URL（含 Vite base），用于 og:url / canonical */
export function buildCanonicalHref(pathname: string): string {
  if (typeof window === 'undefined') return '';
  const base = __BASE_PATH__.replace(/\/$/, '');
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${window.location.origin}${base}${path}`;
}
